var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BoxWrap", { attrs: { title: _vm.$t("menuList.BoxWrap.manage") } }, [
        _c(
          "div",
          { attrs: { slot: "header-right" }, slot: "header-right" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: { pageName: _vm.pageName, list: ["ADD_EDIT"] },
                    expression: "{pageName, list: ['ADD_EDIT']}",
                  },
                ],
                attrs: { type: "primary", size: "small", icon: "el-icon-plus" },
                on: { click: _vm.create },
              },
              [_vm._v(_vm._s(_vm.$t("common.create")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("menuList.BoxWrap.list") },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                stripe: "",
                "highlight-current-row": "",
                "row-key": "menuPk",
                "tree-props": {
                  children: "children",
                  hasChildren: "hasChildren",
                },
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "menuName",
                  label: _vm.$t("menuList.table.menuName"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "menuCode",
                  label: _vm.$t("menuList.table.menuCode"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "menuUrl",
                  label: _vm.$t("menuList.table.menuUrl"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "isTop",
                  formatter: _vm.isTopFormatter,
                  label: _vm.$t("menuList.table.isTop"),
                  width: "80",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "isVirtual",
                  formatter: _vm.isVirtualFormatter,
                  label: _vm.$t("menuList.table.isVirtual"),
                  width: "100",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sn",
                  label: _vm.$t("sysconfig.table.sequence"),
                  width: "80",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("menuList.table.state"),
                  width: "80",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "small",
                              type:
                                scope.row.state === "ENABLE"
                                  ? "success"
                                  : "info",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common." + scope.row.state)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: _vm.$t("menuList.table.createTime"),
                  "min-width": "140",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("menuList.table.action"),
                  fixed: "right",
                  width: "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-button", {
                          directives: [
                            {
                              name: "FPermission",
                              rawName: "v-FPermission",
                              value: {
                                pageName: _vm.pageName,
                                list: ["ADD_EDIT"],
                              },
                              expression: "{pageName, list: ['ADD_EDIT']}",
                            },
                          ],
                          staticClass: "t-square-btn t-grass-green-btn",
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-plus",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.create(scope.row)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("el-button", {
                          directives: [
                            {
                              name: "FPermission",
                              rawName: "v-FPermission",
                              value: {
                                pageName: _vm.pageName,
                                list: ["ADD_EDIT"],
                              },
                              expression: "{pageName, list: ['ADD_EDIT']}",
                            },
                          ],
                          staticClass: "t-square-btn t-green-btn",
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-edit",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.edit(scope.row)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click", size: "medium" } },
                          [
                            _c("el-button", {
                              staticClass: "t-square-btn t-more-btn",
                              attrs: {
                                type: "danger",
                                size: "mini",
                                icon: "el-icon-more",
                                circle: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                scope.row.state === "DISABLED"
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        directives: [
                                          {
                                            name: "FPermission",
                                            rawName: "v-FPermission",
                                            value: {
                                              pageName: _vm.pageName,
                                              list: ["ENABLE_DISABLED"],
                                            },
                                            expression:
                                              "{pageName, list: ['ENABLE_DISABLED']}",
                                          },
                                        ],
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.enableMenu(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("common.ENABLE")))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.state === "ENABLE"
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        directives: [
                                          {
                                            name: "FPermission",
                                            rawName: "v-FPermission",
                                            value: {
                                              pageName: _vm.pageName,
                                              list: ["ENABLE_DISABLED"],
                                            },
                                            expression:
                                              "{pageName, list: ['ENABLE_DISABLED']}",
                                          },
                                        ],
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.disableMenu(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("common.DISABLED"))
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !scope.row.children
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        directives: [
                                          {
                                            name: "FPermission",
                                            rawName: "v-FPermission",
                                            value: {
                                              pageName: _vm.pageName,
                                              list: ["DELETE"],
                                            },
                                            expression:
                                              "{pageName, list: ['DELETE']}",
                                          },
                                        ],
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.deleteItem(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("common.delete")))]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            form: _vm.form,
            "init-form": _vm.initForm,
            "is-show": _vm.isShowModel,
            "dialog-status": _vm.dialogStatus,
            "refresh-data": _vm.refreshData,
            "save-item": _vm.saveItem,
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowModel = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowModel = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: { model: _vm.form, rules: _vm.rules, size: "small" },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.parentMenuPk,
                      expression: "form.parentMenuPk",
                    },
                  ],
                  attrs: {
                    prop: "parentMenuName",
                    label: _vm.$t("menuList.form.parentMenuName"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { readonly: "", autocomplete: "off" },
                    model: {
                      value: _vm.form.parentMenuName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "parentMenuName", $$v)
                      },
                      expression: "form.parentMenuName",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false",
                      },
                    ],
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.parentMenuPk,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "parentMenuPk", $$v)
                      },
                      expression: "form.parentMenuPk",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "menuName",
                    label: _vm.$t("menuList.form.menuName"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.menuName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "menuName", $$v)
                      },
                      expression: "form.menuName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "menuCode",
                    label: _vm.$t("menuList.form.menuCode"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.menuCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "menuCode", $$v)
                      },
                      expression: "form.menuCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "menuUrl",
                    label: _vm.$t("menuList.form.menuUrl"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.menuUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "menuUrl", $$v)
                      },
                      expression: "form.menuUrl",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "menuIcon",
                    label: _vm.$t("menuList.form.menuIcon"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.menuIcon,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "menuIcon", $$v)
                      },
                      expression: "form.menuIcon",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "component",
                    label: _vm.$t("menuList.form.component"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.component,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "component", $$v)
                      },
                      expression: "form.component",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "isTop",
                    label: _vm.$t("menuList.form.isTop"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "Y" },
                      model: {
                        value: _vm.form.isTop,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isTop", $$v)
                        },
                        expression: "form.isTop",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("menuList.form.yes")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "N" },
                      model: {
                        value: _vm.form.isTop,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isTop", $$v)
                        },
                        expression: "form.isTop",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("menuList.form.no")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "isVirtual",
                    label: _vm.$t("menuList.form.isVirtual"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "N" },
                      model: {
                        value: _vm.form.isVirtual,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isVirtual", $$v)
                        },
                        expression: "form.isVirtual",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("menuList.form.N")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "V" },
                      model: {
                        value: _vm.form.isVirtual,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isVirtual", $$v)
                        },
                        expression: "form.isVirtual",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("menuList.form.V")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "R" },
                      model: {
                        value: _vm.form.isVirtual,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isVirtual", $$v)
                        },
                        expression: "form.isVirtual",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("menuList.form.R")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "sn",
                    label: _vm.$t("menuList.form.sn"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.sn,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sn", $$v)
                      },
                      expression: "form.sn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "remark",
                    label: _vm.$t("menuList.form.remark"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 4, autocomplete: "off" },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }